import Axios from "axios";
import ErrorMessage from "@/helpers/ErrorMessage";
import JobCard from "@/admin/Scheduler/JobCard";
import ExecutionCard from "@/admin/Scheduler/ExecutionCard";
import _ from "lodash";

import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// import loadLanguages from 'prismjs/components/index.js'
// loadLanguages(['json'])

export default {
  name: "Scheduler",

  data: function () {
    return {
      loading: false,
      stats: null,
      jobs: null,

      // currentJob: null,
      currentJobId: null,

      page: 1,
      limit: 15,

      query: {
        job: "",
        status: "",
      },

      search: "",

      // more
      more: true,
      moreLoading: false,
    };
  },

  created: function () {
    this.fetchStats();
    this.fetchJobs();

    this.$setInterval(() => this.fetchStats(), 5000);
    this.$setInterval(() => this.refreshJobs(), 5000);

    // Init with custom route params
    for (const k in this.$route.query) {
      if (k in this.query) {
        this.query[k] = this.$route.query[k];
      }
    }
  },

  watch: {
    query: {
      handler() {
        this.fetchJobs();

        if (this.isQueryClear) {
          this.$router.replace({ query: {} });
        } else {
          this.$router.replace({ query: this.query });
        }
      },
      deep: true,
    },
  },

  components: {
    JobCard,
    ExecutionCard,
    // VueMarkdown
  },

  computed: {
    fetchQuery() {
      // Pick only values that are not empty string
      return _.pickBy(this.query, (val) => val !== "");
    },
    currentJob() {
      return (
        this.jobs && this.jobs.find((test) => test._id == this.currentJobId)
      );
    },
  },
  methods: {
    openJob(job) {
      this.currentJobId = job._id;
    },
    getJob(job) {
      if (job._id) this.query.job = job._id;
      else this.query.job = "";
    },
    updateJob(job) {
      const index = this.jobs.findIndex((test) => test._id == job._id);
      if (index < 0) {
        this.jobs.unshift(job);
      } else {
        this.$set(this.jobs, index, job);
      }
    },

    fetchStats: function (forceLoading) {
      this.loading = forceLoading ? true : !this.stats;
      Axios.get("agenda/stats").then(
        (res) => {
          this.loading = false;

          this.stats = res.data;
        },
        (err) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: ErrorMessage(err),
          });
        },
      );
    },
    refreshJobs() {
      const query = this.fetchQuery;

      const params = Object.assign(
        {
          page: 0,
          limit: this.limit,
        },
        query,
      );

      Axios.get("agenda/jobs", { params }).then((res) => {
        // if(!this.jobs) this.jobs = []
        this.jobs && res.data.map(this.updateJob.bind(this));
        this.jobs = _.sortBy(this.jobs, (job) => [
          job.job.nextRunAt,
          job.job.lastRunAt,
          job.job.lastFinishedAt,
        ]).reverse();
      });
    },
    fetchMore: function () {
      this.fetchJobs(true);
    },
    fetchJobs: function (more) {
      if (more) {
        this.loading = false;
        this.page = this.page + 1;
        this.moreLoading = true;
      } else {
        this.loading = true;
        this.page = 0;
        this.more = true;
        this.moreLoading = true;
      }

      const query = this.fetchQuery;

      const params = Object.assign(
        {
          page: this.page,
          limit: this.limit,
        },
        query,
      );

      Axios.get("agenda/jobs", { params }).then(
        (res) => {
          this.loading = false;
          this.moreLoading = false;

          if (more && this.jobs) {
            // Append data
            this.jobs = this.jobs.concat(res.data);
          } else {
            // Replace data
            this.jobs = res.data;
          }

          // Check data is less than limit
          if (res.data.length < this.limit) {
            this.more = false;
          }
        },
        (err) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: ErrorMessage(err),
          });
        },
      );
    },

    highlightHtml(code) {
      if (typeof code === "object") code = JSON.stringify(code || "", null, 2);

      return Prism.highlight(code, Prism.languages.javascript, "javascript");
    },
  },
};



// WEBPACK FOOTER //
// ./src/admin/Scheduler/Scheduler.js